import { render, staticRenderFns } from "./NewsImpactRenderer.vue?vue&type=template&id=07547d5e&"
import script from "./NewsImpactRenderer.vue?vue&type=script&lang=js&"
export * from "./NewsImpactRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports